<template>
    <li class="sku-item">
        <a :href="'/pages/product_detail/promotion_detail/promotion_detail.html?proid='+itemP.promotionId" class="analysis" data-analysis="进入商品详情">
            <template v-for="(pic,index) in itemP.picMap.picPromotionList" v-if="index<=0">
                <img :src="pic">
            </template>
        </a>
        <div class="sku-info">
            <h3>{{itemP.productName}}</h3>
            <p>{{itemP.productTagName}}</p>
        </div>
        <div class="sku-opera">
            <p class="sku-price">
                <span class="sku-origin-price" style="text-decoration: line-through;">原价¥{{itemP.price}}/{{itemP.productUnit}}</span>
                <span class="sku-fact-price">
                    <b :class="'sku-'+vipDay+'-price'" :style="{display:vipDay=='isvipday'&&vipLevel>0?'inline-block':'none'}" v-html="vipLevel>0?'V'+vipLevel+'<em>价</em>':''"></b>
                    <em class="sku-price-count">¥{{itemP.salePrice}}/{{itemP.productUnit}}</em>
                </span>
            </p>
            <template v-if="itemP.seconds>0&&itemP.balanceCount>0">
                <template v-if="itemP.isShow==1">
                    <!--<template v-if="itemP.promotionId=='1080348556029726720'&&generCartPrice<90">-->
                    <template v-if="itemP.promotionId=='1080342771757355008'&&generCartPrice<90">
                        <div class="btn-wrap">
                            <button class="buy-btn" >暂未解锁</button>
                        </div>
                    </template>
                    <template v-else>
                        <proOpera :itemPro="itemP" :speedUp="itemP.speedUp" :stockCount="itemP.speedupStockNum" :proId="itemP.promotionId" :promoId="itemP.promotionId" :protype="1" :proLimit="itemP.limitBuyCount" :proName="itemP.productName"></proOpera>
                    </template>
                </template>
                <template v-else>
                    <div class="btn-wrap" @click="vipProTips">
                        <button class="buy-btn" >暂未解锁</button>
                    </div>
                </template>
            </template>
            <template v-else>
                <div class="btn-wrap">
                    <button class="buy-btn" :class="itemP.balanceCount<=0?'but-btn-tips':''" @click="hasInventoryTips(itemP.promotionId)">{{itemP.balanceCount<=0?'到货提醒':'已结束'}}</button>
                </div>
            </template>
            <!--<proOpera :cartData="cartData" :speedUp="itemP.speedUp" :stockCount="itemP.speedupStockNum" :proId="itemP.productId" :promoId="itemP.promotionId" :protype="4" :proLimit="itemP.limitBuyCount" :proName="itemP.productName" @deliverDateS="deliverDateS"></proOpera>-->
        </div>
        <span class="speed-tips" v-if="itemP.speedUp=='1'"></span>
        <span class="store-tips" v-else :class="'pro-delay-'+setId(itemP.speedUp)+itemP.productId" ></span>

    </li>
</template>

<script>
    import proOpera from '@/components/index/product_opera.vue'

    export default{
        props:['itemP','vipLevel','vipDay'],
        components:{
            proOpera
        },
        methods:{
            setId(item){
                return item!=undefined?item+'-':''
            },
            vipProTips(){
                let _this = this;
                this.$prompt('您的当前会员等级：V'+_this.vipLevel+'<br/>买买买升到相应等级，可以购买噢！')
            },
            hasInventoryTips(id){
                let _this = this;
                invokeApi('reserve/reserve',{aliasId:id,type:1},'get',Math.random(),function (res) {
                    console.log(res);
                    _this.$prompt(res)
                })
            }
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss">
    @import "../../resource/css/color";
    /**sku**/
    .sku-content, .milk-content {
        background: #ffffff;
    }

    .sku-item {
        position: relative;
        width: 50%;
        float: left;
        background: #ffffff;
        box-sizing: border-box;
        padding: .2rem .2rem .45rem;
        border-right: 1px solid #f2f2f2;
        border-bottom: 1px solid #f2f2f2;
        height: 5.0rem;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-box-pack: justify;
        .buy-btn{
            background: #d2d2d2;
            color: #fff;
            border-radius: .1rem;
            font-size: .24rem;
            padding: .1rem .2rem;
        }
        .but-btn-tips{
            background: none;
            color: #e50011;
            border: 1px solid;
        }
    }

    .sku-item a img {
        width: 2.4rem;
        display: block;
        margin: 0 auto .1rem;
    }

    .sku-info {
        height: 1.1rem;
        margin-bottom: .2rem;
    }

    .sku-info h3 {
        font-size: .26rem;
        margin-bottom: .05rem;
        font-weight: normal;
    }

    .sku-info p {
        font-size: .22rem;
        color: #666666;
    }

    .sku-opera {
        display: -webkit-box;
        -webkit-box-pack: justify;
        -webkit-box-align: end;
    }

    .sku-price {
        position: relative;
        color: #e50011;
        padding-top: .36rem;
        width: 1.5rem;
        -webkit-box-flex: 1;
        font-size: .26rem;
    }

    .sku-price span {
        display: block;
    }

    .sku-origin-price {
        position: absolute;
        top: .06rem;
        left: 0;
        color: rgb(239, 102, 112);
        font-size: .2rem;
    }

    .sku-fact-price {
        color: #e50011;
        font-size: .26rem;
    }

    .sku-fact-price b {
        display: none;
        font-size: .22rem;
        color: #ffffff;
        width: .55rem;
        height: .31rem;
        background: url('./images/index-price-bg.png') top left no-repeat;
        background-size: .55rem auto;
        margin-right: .03rem;
        font-weight: normal;
        text-align: center;
        line-height: .32rem;
    }

    .sku-fact-price b em {
        font-size: .18rem;
        margin-right: .02rem;
    }

    .sku-fact-price > i {
        font-style: normal;
        position: relative;
        top: .02rem;
    }

    .sku-fact-price .sku-price-count {
        font-style: normal;
        position: relative;
        top: .02rem;
        font-size: .24rem;
    }

    .sku-item .sku-notvipday-price {
        display: none;
    }
    .speed-tips{
        position: absolute;
        top:0;
        left: .2rem;
        width: .56rem;
        height:.66rem;
        display: block;
        background: url("./images/speed-icon.png") top left no-repeat;
        background-size: .56rem .66rem;
    }



</style>


// WEBPACK FOOTER //
// src/components/module_pro/sku_promotion.vue